export interface IEventDetailAdapter{
    Area:           string;
    AssignedTo:     string;
    Attendees:      IAttendeeAdapter[];
    ChangeHistory:  IChangeHistoryAdapter[];
    Code:           string;
    Comment:        string;
    End:            Date;
    OtpAvailable:   boolean;
    Service:        string;
    Slot:           string;
    Start:          Date;
    Status:         EMeetingStatus;
    InTime:         EEventInTime;
    Observations:  string;
    isDocumentationAvailable: boolean;
    
    Subjects1?: ISubjectAdapter[];
    Subjects2?: ISubjectAdapter[];
    Subjects3?: ISubjectAdapter[];
}

export interface IEventDetailAdapterIndex extends IEventDetailAdapter{
    serviceCode:      string;
    code:             string;
}


export interface IEventDetailResponse {
    slotId:           string;
    start:            Date;
    end:              Date;
    createDate:       Date;
    lastModifiedDate: Date;
    isOtpAvailable:   boolean;
    status:           string;
    reason:           null;
    serviceCode:      string;
    comment:          string;
    attendees:        IAttendee[];
    changeHistory:    IChangeHistory[];
    code:             string;
    observations?:     string;
    isDocumentationAvailable: boolean;
    subjects1?: ISubjectAdapter[];
    subjects2?: ISubjectAdapter[];
    subjects3?: ISubjectAdapter[];
}

export interface ISubjectAdapter {
    code: string;
    description: string;
}

export interface IAttendeeAdapter{
    Name:           string;
    Phone:          string;
    ID:             string
    Mail?:           string;
}

export interface IAttendee {
    fullName:     string;
    culture:      string;
    email:        string;
    phone:        string;
    type:         string;
    isOrganizer:  boolean;
    personId:     string;
    personIdType: string;
}

export interface IChangeHistory {
    date:       Date;
    changeType: string;
    changeInfo: string;
}

export interface IChangeHistoryAdapter {
    Date:       Date;
    Type:       string;
    Info:       string;
}

export enum EMeetingStatus {
    SCHEDULED = "Scheduled",
    SCHEDULED_EXPRESS = "ScheduledExpress",
    SCHEDULED_PROGRAMMED = "ScheduledProgrammed",
    SCHEDULED_CUSTOM = "ScheduledCustom",
    WAITING_FOR_CITIZEN = "WaitingForCitizen",
    CITIZEN_WAITING = "CitizenWaiting",
    IN_PROGRESS = "InProgress",
    FINALIZED = "Finalized",
    CANCELLED = "Cancelled",
    NOT_ATTENDEED = "NotAttendeed",
    UNKNOWN = "Unknown"
}
  
  export enum EEventInTime{
    EarlyAccess = "EarlyAccess",
    LaterAccess = "LaterAccess",
    InTime = "InTime"
}
